/** Cookie consent category identifiers. */
export type CookieCategory = 'necessary' | 'analytics' | 'marketing' | 'preferences';

/** Persisted user consent (necessary is always true). */
export interface ConsentState {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  preferences: boolean;
  timestamp: number;
  version: string;
}

/** Metadata for a single cookie used in the preferences panel. */
export interface CookieInfo {
  name: string;
  provider: string;
  purpose: string;
  expiry: string;
}

/** UI configuration for one consent category. */
export interface CookieCategoryConfig {
  id: CookieCategory;
  label: string;
  description: string;
  required: boolean;
  cookies: CookieInfo[];
}

/** Options passed when setting a document cookie. */
export interface SetCookieOptions {
  expires?: Date | number;
  path?: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'Strict' | 'Lax' | 'None';
}

/** Optional UI strings from Flask i18n (RO/EN). */
export interface CookieConsentUiStrings {
  banner?: string;
  policyLink?: string;
  acceptAll?: string;
  rejectAll?: string;
  customize?: string;
  dialogLabel?: string;
  modalTitle?: string;
  close?: string;
  enableCategory?: string;
  openSettingsAria?: string;
  openSettingsTitle?: string;
  savePreferences?: string;
  alwaysActive?: string;
  settingsTitle?: string;
  [key: string]: string | undefined;
}

export interface CookieConsentConfig {
  policyVersion: string;
  cookiesPolicyUrl: string;
  gaTrackingId?: string;
  facebookPixelId?: string;
  ui?: Partial<CookieConsentUiStrings>;
  categories?: CookieCategoryConfig[];
}

export const CONSENT_STORAGE_KEY = 'cookie_consent';
export const CONSENT_CHANGED_EVENT = 'cookieConsentChanged';
